import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds
} from 'date-fns';

import { TIME } from '@swf/poker';

export default function getTimeDiff(end: number, start: number) {
  let timeLeft = end;

  const days = differenceInDays(timeLeft, start);
  timeLeft -= days * TIME.DAY;

  const hours = differenceInHours(timeLeft, start);
  timeLeft -= hours * TIME.HOUR;

  const minutes = differenceInMinutes(timeLeft, start);
  timeLeft -= minutes * TIME.MINUTE;

  const seconds = differenceInSeconds(timeLeft, start);

  return { days, hours, minutes, seconds };
}
